import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { trc20_abi } from '../../contracts/trc20_abi'
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';

@Component({
  selector: 'app-trans-details',
  templateUrl: './trans-details.component.html',
  styleUrls: ['./trans-details.component.css']
})
export class TransDetailsComponent implements OnInit {
  transactionId: any;
  transactionInfo: any;
  searchobj: any = {
    searchAddress: ''
  }
  searchListDetails: any;
  transactionTime: number;
  timeString: string = '';
  transactiondeployInfo: any;
  transactiondeployTime: number;
  result: any;
  contractInputs: any;
  method: any;
  sasttransactionInfo: any;
  sasttransactionTime: number;

  constructor(private conn: ConnectionService, private activatedRoute: ActivatedRoute,
    private alert: ToastrService, private spinner: NgxSpinnerService) {
    this.transactionId = this.activatedRoute.snapshot.params['id'];
    this.method = this.activatedRoute.snapshot.params['name']
  }

  ngOnInit() {
    setTimeout(() => {
      this.getTransaction();
      this.getDeplolyTrans();
      this.getTransInfo()
    }, 1000)

    setTimeout(() => {
      this.calculateTimeRemaining()
    }, 3000)
  }


  isDecimalNumber(num: number): boolean {
    return num % 1 !== 0;
  }

  getTransaction() {
    this.spinner.show()
    this.conn.postUrl('contract/getTransactions', { transactionHash: this.transactionId })
      .subscribe((res: any) => {
        if (res) {
          this.spinner.hide()
          this.transactionInfo = res.data
          this.transactionTime = new Date(this.transactionInfo?.created_at).getTime()
        }
        else {
          this.spinner.hide()
        }
      }
      )
  }

  getTransInfo() {
    this.spinner.show()
    this.conn.postUrl('users/getTransDetails', { transactionId: this.transactionId }).subscribe((resp: any) => {
      if (resp.success == true) {
        this.spinner.hide()
        this.sasttransactionInfo = resp.data[0]
        this.sasttransactionTime = new Date(this.sasttransactionInfo.updated_at).getTime()
      }
      else {
        this.spinner.hide()
      }
    })
  }



  getDeplolyTrans() {
    this.spinner.show()
    this.conn.postUrl('user_contract/getContractInfobyHash', { hash: this.transactionId }).subscribe((res: any) => {
      if (res) {
        this.spinner.hide()
        this.transactiondeployInfo = res.data
        this.transactiondeployTime = new Date(this.transactiondeployInfo?.created_at).getTime()
      }
    })
  }

  calculateTimeRemaining() {
    const currentTime = new Date().getTime();
    if (this.transactiondeployTime) {
      const timeDifference = currentTime - this.transactiondeployTime;
      if (timeDifference > 0) {
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        setTimeout(() => {
          this.calculateTimeRemaining();
        }, 1000);
      } else {
        // this.timeString = 'Timer expired!';
      }
    }
    else if (this.sasttransactionInfo) {
      const timeDifference = currentTime - this.sasttransactionTime;
      if (timeDifference > 0) {
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        setTimeout(() => {
          this.calculateTimeRemaining();
        }, 1000);
      } else {
        // this.timeString = 'Timer expired!';
      }
    }
    else {
      const timeDifference = currentTime - this.transactionTime;
      if (timeDifference > 0) {
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        setTimeout(() => {
          this.calculateTimeRemaining();
        }, 1000);
      } else {
        // this.timeString = 'Timer expired!';
      }
    }
  }

  searchDetails(type: any) {
    this.conn.postUrl('users/search', { type: type, searchTerm: this.searchobj.searchAddress }).subscribe((res: any) => {
      if (res.success == true) {
        this.alert.success(res.msg);
      }
      else if (res.success == false) {
        this.alert.error(res.msg)
      }
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
